import { Box, Button, Typography } from '@mui/material';
import React, { useContext } from 'react'
import Bid from '../../components/Quote/Bid';
import Ask from '../../components/Quote/Ask';
import { ThemeContext } from '../../../context/ThemeContext';
import AmountInput from '../../components/Quote/AmountInput';
import { useTranslation } from 'react-i18next';

export default function SimpleOneClickView({ symbol, handleTrade }) {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()

    return (
        <>
            <Box sx={{ p: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Ask symbolId={symbol?.id} />
                        <Button variant='outlined' size='small' fullWidth sx={{ px: 3 }} color='error' onClick={e => handleTrade(-1, symbol?.id)}>{t('sell')}</Button>
                    </Box>
                </Box>
                <Box sx={{ backgroundColor: darkMode ? "#151924" : 'var(--white)', textAlign: "center", display: "flex", flexDirection: "column", alignItems: 'center' }}>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)', margin: 0 }}>{symbol?.name}</Typography>
                    <AmountInput symbolId={symbol?.id} />
                </Box>
                <Box>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Bid symbolId={symbol?.id} />
                        <Button variant='outlined' size='small' fullWidth sx={{ px: 3 }} color='success' onClick={e => handleTrade(1, symbol?.id)}>{t('buy')}</Button>
                    </Box>
                </Box>
            </Box>

        </>
    )
}
